import React from "react";

const socialLinks = [
  {
    href: "https://facebook.com/movesoffer",
    label: "Facebook",
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
        <path d="M22 12.06C22 6.48 17.52 2 11.94 2S2 6.48 2 12.06c0 5.01 3.66 9.17 8.44 9.94v-7.03H7.9v-2.91h2.54V9.41c0-2.5 1.49-3.88 3.77-3.88 1.09 0 2.24.2 2.24.2v2.47h-1.26c-1.24 0-1.63.77-1.63 1.56v1.87h2.78l-.44 2.91h-2.34V22c4.78-.77 8.44-4.93 8.44-9.94Z" />
      </svg>
    ),
  },
  {
    href: "https://x.com/movesoffer",
    label: "X / Twitter",
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
        <path d="M19.8 3H22l-6.73 7.69L23 21h-6.06l-4.74-6.2L6.8 21H2l7.26-8.31L1.5 3h6.2l4.3 5.7L19.8 3Zm-2.13 16h1.32L8.4 5H7.02L17.67 19Z" />
      </svg>
    ),
  },
  {
    href: "https://www.instagram.com/movesoffer/",
    label: "Instagram",
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
        <path d="M7 2h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5Zm0 2a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H7Zm5 3.5A5.5 5.5 0 1 1 6.5 13 5.5 5.5 0 0 1 12 7.5Zm0 2A3.5 3.5 0 1 0 15.5 13 3.5 3.5 0 0 0 12 9.5Zm5.75-2.25a.75.75 0 1 1-.75.75.75.75 0 0 1 .75-.75Z" />
      </svg>
    ),
  },
];

const SocialLinks = () => {
  return (
    <div className="flex items-center gap-3 sm:gap-4 text-gray-500 flex-shrink-0">
      {socialLinks.map((link) => (
        <a
          key={link.label}
          href={link.href}
          target="_blank"
          rel="noreferrer"
          aria-label={link.label}
          className="hover:text-primary flex-shrink-0"
        >
          {link.icon}
        </a>
      ))}
    </div>
  );
};

export default SocialLinks;
